/* eslint-disable react/style-prop-object */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars-2';
import styled from 'styled-components';

const ScrollContainer = styled.div``;

class ShadowScrollbars extends Component {
  static propTypes = {
    style: PropTypes.objectOf(PropTypes.any).isRequired,
    tabIndex: PropTypes.number
  };

  constructor(props, ...rest) {
    super(props, ...rest);
    this.state = {};
  }

  render() {
    const { style, hideScroll, tabIndex, ...props } = this.props;
    const containerStyle = {
      ...style,
      position: 'relative',
    };

    return (
      <ScrollContainer style={containerStyle} id="scroll-container" >
        <Scrollbars {...props} renderView={(props) => (
          <div {...props} tabIndex={tabIndex || 0} />
        )
        } />
      </ScrollContainer>
    );
  }
}

export default ShadowScrollbars;
